import { PublicClientApplication } from '@azure/msal-browser';
import type { Configuration } from '@azure/msal-browser';

import { ENV } from '@/shared/config/env';

const clientId = 'be94c0ef-acc0-45da-ad1c-4023f53c5822';
const instance = 'https://mobexocustomersdirectory.b2clogin.com';
const redirectUri = ENV.IS_PROD_RUNTIME
  ? ENV.IS_PROD_MODE
    ? 'https://app.mobexo.de/signin-oidc'
    : ENV.IS_STAGING_MODE
      ? 'https://app-mobexo-de-frontend-staging.azurewebsites.net/signin-oidc'
      : 'https://portal-mobexo-de-frontend-sandbox.azurewebsites.net/signin-oidc'
  : 'http://localhost:3000/signin-oidc';
const signInPolicy = ENV.IS_PROD_MODE ? 'B2C_1A_SIGNIN_SSO_PROD' : 'B2C_1A_SIGNIN_SSO_DEV';
const tenant = 'mobexocustomersdirectory.onmicrosoft.com';

export const authority = `${instance}/${tenant}/${signInPolicy}`;

export const b2cPolicies = {
  names: {
    signIn: ENV.IS_PROD_MODE ? 'B2C_1A_SIGNIN_SSO_PROD' : 'B2C_1A_SIGNIN_SSO_DEV',
    forgotPassword: 'B2C_1_password_reset'
  }
};

const msalConfig: Configuration = {
  auth: {
    authority: `${instance}/${tenant}/${signInPolicy}`,
    clientId,
    knownAuthorities: ['mobexocustomersdirectory.b2clogin.com'],
    postLogoutRedirectUri: '/',
    redirectUri
  },
  cache: {
    cacheLocation: 'localStorage'
  }
};

export const loginRequest = {
  scopes: ['https://mobexocustomersdirectory.onmicrosoft.com/mobexo/read']
};

export const forgotPasswordRequest = {
  authority:
    'https://mobexocustomersdirectory.b2clogin.com/mobexocustomersdirectory.onmicrosoft.com/B2C_1_password_reset'
};

export const msalInstance = new PublicClientApplication(msalConfig);
